import { genericMemo } from "@redotech/react-util/component";
import { DropTargetMonitor, useDrop } from "react-dnd";
import { FormElementDrag } from "./form-element-drag";

export const FormElementDrop = genericMemo(function FormElementDrop<
  T extends string,
>({
  elementDropped,
  possibleValues,
}: {
  elementDropped(elementType: T): void;
  possibleValues: readonly T[];
}) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: [...possibleValues],
      drop(_item: typeof FormElementDrag, monitor) {
        elementDropped(monitor.getItemType() as any);
        return undefined;
      },
      collect: (monitor: DropTargetMonitor) => ({
        isOver: monitor.isOver(),
      }),
    }),
    [elementDropped],
  );

  return (
    <div ref={drop} style={{ height: "16px", padding: "6px" }} width="100%">
      {isOver && (
        <div
          style={{
            height: "4px",
            background: "#4D35C6",
          }}
        />
      )}
    </div>
  );
});
